import { Directive, HostListener, Input } from '@angular/core';
import { MmuAnalyticsService } from './mmu-analytics.service';


@Directive({
  selector: '[mmuTrackEvent]'
})
export class MmuTrackEventDirective {
  @Input()
  trackCategory?: string;

  @Input()
  trackLabel?: string;

  @Input()
  trackAction?: string;

  @Input()
  trackData?: Record<string, string | number>;

  constructor(private analyticsService: MmuAnalyticsService) {
  }

  @HostListener('click') onClick(): void {
    if ((!this.trackCategory && !this.trackAction) || (this.trackCategory && this.trackAction && !this.trackData && !this.trackLabel)) {
      console.error('Analytics Service can\'t handle the click, some information is missing!');
      return;
    }

    if (this.trackData && this.trackCategory && this.trackAction) {
      this.analyticsService.emitCustomEvent(this.trackCategory, this.trackAction, this.trackData);
    } else if (this.trackLabel && this.trackCategory && this.trackAction) {
      this.analyticsService.emitEvent(this.trackCategory, this.trackAction, this.trackLabel);
    }
  }
}
